import { render, staticRenderFns } from "./FormResponder.vue?vue&type=template&id=87a2c09c&scoped=true"
import script from "./FormResponder.vue?vue&type=script&lang=ts"
export * from "./FormResponder.vue?vue&type=script&lang=ts"
import style0 from "./FormResponder.vue?vue&type=style&index=0&id=87a2c09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a2c09c",
  null
  
)

export default component.exports